import { Put, Post, Delete, Get } from "./common";

export default class BidService {
  static create = async (token: string, data: any) =>
    await Post({ path: "bids", token, body: data });

  static update = async (id: string, token: string, data: any) =>
    await Put({ path: `bids/${id}`, token, body: data });

  static getById = async (id: string) => await Get({ path: `bids/${id}` });

  static deleteById = async (id: string, token: string) =>
    await Delete({ path: `bids/${id}`, token });

  static getMine = async (token: string, data: any) =>
    await Post({ path: "bids/mine", token, body: data });
}
